// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"NativeVariablesButton-module__ButtonRoot___p_nIr","isSelected":"NativeVariablesButton-module__isSelected___SdAAt"};